import { type List, type Map } from "immutable";

import {
	type Action,
	type ColumnAppendAction,
	type ColumnDeleteAction,
	type ColumnRenameAction,
	type ColumnTypeChangeAction,
	type MutationAction,
	type QueryRegistrationAction,
} from "./Action";
import { type QueryEvaluatorState } from "./QueryManagerState";
import { type TableMutation } from "./TableMutation";

export type MutationActionIntent = {
	action: MutationAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId: Map<string, List<TableMutation<unknown>>>;
};
export const isMutationActionIntent = (
	actionIntent: unknown
): actionIntent is MutationActionIntent => {
	// @ts-ignore
	return typeof actionIntent === "object" && actionIntent?.["action"]?.["type"] === "mutation";
};

export type RegisterQueryActionIntent = {
	action: QueryRegistrationAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId?: undefined;
};

export interface ColumnAppendActionIntent {
	action: ColumnAppendAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId: Map<string, List<TableMutation<unknown>>>;
}

export const isColumnAppendActionIntent = (
	actionIntent: unknown
): actionIntent is ColumnAppendActionIntent => {
	return (
		// @ts-ignore
		typeof actionIntent === "object" && actionIntent?.["action"]?.["type"] === "columnAppend"
	);
};

export interface ColumnDeleteActionIntent {
	action: ColumnDeleteAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId: Map<string, List<TableMutation<unknown>>>;
}

export const isColumnDeleteActionIntent = (
	actionIntent: unknown
): actionIntent is ColumnDeleteActionIntent => {
	return (
		// @ts-ignore
		typeof actionIntent === "object" && actionIntent?.["action"]?.["type"] === "columnDelete"
	);
};

export interface ColumnRenameActionIntent {
	action: ColumnRenameAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId: Map<string, List<TableMutation<unknown>>>;
}

export const isColumnRenameActionIntent = (
	actionIntent: unknown
): actionIntent is ColumnRenameActionIntent => {
	return (
		// @ts-ignore
		typeof actionIntent === "object" && actionIntent?.["action"]?.["type"] === "columnRename"
	);
};

export interface ColumnTypeChangeActionIntent {
	action: ColumnTypeChangeAction;
	proposedState: QueryEvaluatorState;
	changesByQueryId: Map<string, List<TableMutation<unknown>>>;
}

export const isColumnTypeChangeActionIntent = (
	actionIntent: unknown
): actionIntent is ColumnTypeChangeActionIntent => {
	return (
		typeof actionIntent === "object" &&
		actionIntent !== null &&
		"action" in actionIntent &&
		typeof actionIntent.action === "object" &&
		actionIntent.action !== null &&
		"type" in actionIntent.action &&
		actionIntent.action.type === "columnTypeChange"
	);
};

export type ActionIntent =
	| MutationActionIntent
	| RegisterQueryActionIntent
	| ColumnAppendActionIntent
	| ColumnDeleteActionIntent
	| ColumnRenameActionIntent
	| ColumnTypeChangeActionIntent;
